import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/att-point.png'


const _hoisted_1 = { class: "home-staking v2-agenda" }
const _hoisted_2 = { class: "agenda staking" }
const _hoisted_3 = { class: "container back-agenda" }
const _hoisted_4 = { class: "top-box" }
const _hoisted_5 = { class: "category" }
const _hoisted_6 = { class: "point" }
const _hoisted_7 = { class: "mid-box" }
const _hoisted_8 = { class: "mid-box-top" }
const _hoisted_9 = {
  class: "mid-box-mid max-width row chart-border",
  style: {"height":"264px"}
}
const _hoisted_10 = { class: "top-box" }
const _hoisted_11 = { class: "category" }
const _hoisted_12 = { class: "point" }
const _hoisted_13 = { class: "mid-box" }
const _hoisted_14 = { class: "mid-box-top" }
const _hoisted_15 = { class: "mid-box-mid max-width row" }
const _hoisted_16 = { class: "mid-box-mid-inner col-6" }
const _hoisted_17 = { class: "text-box" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "point" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_22 = { class: "mid-box-mid-inner col-6" }
const _hoisted_23 = { class: "text-box" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "name" }
const _hoisted_26 = { class: "point" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_28 = { class: "mid-box-mid-inner col-6" }
const _hoisted_29 = { class: "text-box" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = { class: "point" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "VP", -1)
const _hoisted_34 = { class: "mid-box-mid-inner col-6" }
const _hoisted_35 = { class: "text-box" }
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "name" }
const _hoisted_38 = { class: "point" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_40 = { class: "btn-box" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "top-box2" }, [
  /*#__PURE__*/_createElementVNode("p")
], -1)
const _hoisted_42 = { class: "mid-box" }
const _hoisted_43 = { class: "mid-box-top" }
const _hoisted_44 = { class: "second" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "icon-attpoint" }, null, -1)
const _hoisted_46 = { class: "mid-box-mid max-width row" }
const _hoisted_47 = { class: "mid-box-mid-inner col-6" }
const _hoisted_48 = { class: "text-box" }
const _hoisted_49 = { class: "title" }
const _hoisted_50 = { class: "name" }
const _hoisted_51 = { class: "point" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", null, "APR", -1)
const _hoisted_53 = { class: "mid-box-mid-inner col-6" }
const _hoisted_54 = { class: "text-box" }
const _hoisted_55 = { class: "title" }
const _hoisted_56 = { class: "name" }
const _hoisted_57 = { class: "point" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_59 = { class: "mid-box-row row" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_61 = { class: "col-10" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", null, "Max", -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { class: "btn-box" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "top-box2" }, [
  /*#__PURE__*/_createElementVNode("p")
], -1)
const _hoisted_66 = { class: "mid-box" }
const _hoisted_67 = { class: "mid-box-top" }
const _hoisted_68 = { class: "second" }
const _hoisted_69 = { class: "mid-box-mid max-width row" }
const _hoisted_70 = { class: "mid-box-mid-inner col-6" }
const _hoisted_71 = { class: "text-box" }
const _hoisted_72 = { class: "title" }
const _hoisted_73 = { class: "name" }
const _hoisted_74 = { class: "point" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_76 = { class: "mid-box-mid-inner col-6" }
const _hoisted_77 = { class: "text-box" }
const _hoisted_78 = { class: "title" }
const _hoisted_79 = { class: "name" }
const _hoisted_80 = { class: "point" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", null, "ATT", -1)
const _hoisted_82 = { class: "mid-box-row row" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_84 = { class: "col-10" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("p", null, "Max", -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = { class: "btn-box" }
const _hoisted_88 = { class: "container back-agenda stake-sec2" }
const _hoisted_89 = { class: "stake-table" }
const _hoisted_90 = { class: "stake-table-head" }
const _hoisted_91 = { class: "date" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", { class: "mb-stake-br" }, null, -1)
const _hoisted_93 = { class: "quantity" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", { class: "mb-stake-br" }, null, -1)
const _hoisted_95 = { class: "apr" }
const _hoisted_96 = { class: "acummulation" }
const _hoisted_97 = { class: "date date2" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("br", { class: "mb-stake-br" }, null, -1)
const _hoisted_99 = { class: "lock-up" }
const _hoisted_100 = { class: "date" }
const _hoisted_101 = { class: "quantity" }
const _hoisted_102 = { class: "apr" }
const _hoisted_103 = { class: "acummulation" }
const _hoisted_104 = { class: "date date2" }
const _hoisted_105 = { class: "lock-up" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_PopupShow = _resolveComponent("PopupShow")!
  const _component_PopupOk = _resolveComponent("PopupOk")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("staking.staking")), 1),
        _createVNode(_component_ui_grid, {
          class: "demo-grid max-width agenda-box staking-box",
          position: "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_grid_cell, {
              class: "demo-cell staking-chart",
              columns: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("staking.att-token-pool")), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$filters.comma(_ctx.stakingWeekTotal)) + " " + _toDisplayString(_ctx.$t("staking.att")), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("staking.att-pool-total-value-locked")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_LineChart, {
                      "chart-data": _ctx.chartData,
                      options: _ctx.chartOptions,
                      style: {"height":"100%"}
                    }, null, 8, ["chart-data", "options"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ui_grid_cell, {
              class: "demo-cell mystats",
              columns: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("staking.my-stats")), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.total)) + " " + _toDisplayString(_ctx.$t("staking.att")), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t("staking.total-asset")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("staking.staking-value")), 1),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("staking.att")), 1),
                        _createElementVNode("p", _hoisted_20, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.stakingTotal)) + " ", 1),
                          _hoisted_21
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("staking.accumulated-compensation")), 1),
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("staking.att")), 1),
                        _createElementVNode("p", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.accumulateRewardPoint)) + " ", 1),
                          _hoisted_27
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("staking.voting-power")), 1),
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("staking.vp")), 1),
                        _createElementVNode("p", _hoisted_32, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.votePower)) + " ", 1),
                          _hoisted_33
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("staking.compensation-quantity")), 1),
                        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("staking.att")), 1),
                        _createElementVNode("p", _hoisted_38, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.rewardPoint)) + " ", 1),
                          _hoisted_39
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("a", {
                    class: "btn-hover",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.receiveConfirm && _ctx.receiveConfirm(...args)))
                  }, _toDisplayString(_ctx.$t("staking.receive")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ui_grid_cell, {
              class: "demo-cell",
              columns: "6"
            }, {
              default: _withCtx(() => [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("h4", _hoisted_44, [
                      _hoisted_45,
                      _createTextVNode(_toDisplayString(_ctx.$t("staking.artube-staking")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("staking.estimated-annual-interest-rate")), 1),
                        _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("staking.apr")), 1),
                        _createElementVNode("p", _hoisted_51, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingInfoData.apr)) + " % ", 1),
                          _hoisted_52
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t("staking.depositable-amount")), 1),
                        _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t("staking.att")), 1),
                        _createElementVNode("p", _hoisted_57, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingInfoData.amount)) + " ", 1),
                          _hoisted_58
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "point-box",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stakingAmount) = $event)),
                        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.commaAmount('staking')))
                      }, null, 544), [
                        [_vModelText, _ctx.stakingAmount]
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-1 max btn-hover",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMaxStakeNumber('staking')))
                    }, _hoisted_63)
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("a", {
                    class: "btn-hover",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stakeConfirm && _ctx.stakeConfirm(...args)))
                  }, _toDisplayString(_ctx.$t("staking.stake")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_ui_grid_cell, {
              class: "demo-cell",
              columns: "6"
            }, {
              default: _withCtx(() => [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("h4", _hoisted_68, _toDisplayString(_ctx.$t("staking.withdraw")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("p", _hoisted_72, _toDisplayString(_ctx.$t("staking.deposit")), 1),
                        _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.$t("staking.att")), 1),
                        _createElementVNode("p", _hoisted_74, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.stakingTotal)) + " ", 1),
                          _hoisted_75
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.$t("staking.available")), 1),
                        _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t("staking.att")), 1),
                        _createElementVNode("p", _hoisted_80, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.comma(_ctx.stakingStateData.withdrawAmount)) + " ", 1),
                          _hoisted_81
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("div", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "point-box",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.unStakingAmount) = $event)),
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.commaAmount('unstaking')))
                      }, null, 544), [
                        [_vModelText, _ctx.unStakingAmount]
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "col-1 max btn-hover",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setMaxStakeNumber('unstaking')))
                    }, _hoisted_86)
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("a", {
                    class: "btn-hover",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.unStakeConfirm && _ctx.unStakeConfirm(...args)))
                  }, _toDisplayString(_ctx.$t("staking.unstaking")), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("staking.staking-history")), 1),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("p", _hoisted_91, [
                _createTextVNode(_toDisplayString(_ctx.$t("staking.date-of")) + " ", 1),
                _hoisted_92,
                _createTextVNode(_toDisplayString(_ctx.$t("staking.subscription")), 1)
              ]),
              _createElementVNode("p", _hoisted_93, [
                _createTextVNode(_toDisplayString(_ctx.$t("staking.staking")), 1),
                _hoisted_94,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("staking.quantity")), 1)
              ]),
              _createElementVNode("p", _hoisted_95, _toDisplayString(_ctx.$t("staking.apr")), 1),
              _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.$t("staking.compensation")), 1),
              _createElementVNode("p", _hoisted_97, [
                _createTextVNode(_toDisplayString(_ctx.$t("staking.date-of")), 1),
                _hoisted_98,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("staking.expiration")), 1)
              ]),
              _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.$t("staking.lockup-end")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stakingHistory, (data, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "stake-table-body",
                key: index
              }, [
                _createElementVNode("p", _hoisted_100, _toDisplayString(data.sDate), 1),
                _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.$filters.comma(data.amount)) + " " + _toDisplayString(data.symbol), 1),
                _createElementVNode("p", _hoisted_102, _toDisplayString(data.apr) + " %", 1),
                _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.$filters.comma(data.rewardAccumulation)) + " " + _toDisplayString(data.symbol), 1),
                _createElementVNode("p", _hoisted_104, _toDisplayString(data.eDate), 1),
                _createElementVNode("p", _hoisted_105, _toDisplayString(_ctx.getRemainTime(data.remainTimeCount)), 1)
              ]))
            }), 128))
          ]),
          (_ctx.currentPageNo < _ctx.pageCount)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "more-box btn-hover",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.moreWaitList && _ctx.moreWaitList(...args)))
              }, _toDisplayString(_ctx.$t("staking.more")), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_PopupShow, {
      initPopupShow: _ctx.popupShow,
      initPopupShowHeader: _ctx.popupShowHeader,
      initPopupShowMessage: _ctx.popupShowMessage,
      initPopupShowData: _ctx.popupShowData,
      initType: _ctx.popupShowType,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.close('PopupShow'))),
      onRequest: _cache[11] || (_cache[11] = ($event: any) => (_ctx.request()))
    }, null, 8, ["initPopupShow", "initPopupShowHeader", "initPopupShowMessage", "initPopupShowData", "initType"]),
    _createVNode(_component_PopupOk, {
      initIsShowPopup: _ctx.popupOkShow,
      initPopupOkHeader: _ctx.popupOkHeader,
      initPopupOkMessage: _ctx.popupOkMessage,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.close('PopupOk')))
    }, null, 8, ["initIsShowPopup", "initPopupOkHeader", "initPopupOkMessage"]),
    _createVNode(_component_Footer)
  ]))
}